// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tab-head b[data-v-6f6881dc] {\n  margin: 0 5px;\n}\n.tabBtn[data-v-6f6881dc] {\n  padding: 10px;\n  border: 1px #e2e7ec solid;\n  border-top: 0;\n}\n.flex-jus[data-v-6f6881dc] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}", ""]);
// Exports
module.exports = exports;
